export default __webpack_public_path__ + "static/media/IPad_2.0596fb6f.png";